import {
  PatientScreener,
  PatientScreenerAnswerControllerApi,
} from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const useScreeningUpdate = (isPublicView?: boolean) =>
  useMutationWithLoading(
    async (params: {
      patientUuid: string;
      patientScreener: PatientScreener;
      xTENANTID?: string;
    }) => {
      return new PatientScreenerAnswerControllerApi(
        isPublicView ? undefined : getConfigObject()
      ).updatePatientScreenerAnswer(
        params?.patientUuid,
        params.patientScreener,
        params.xTENANTID
      );
    }
  );
